import React, { useEffect, useState } from 'react';
import Header from './Header';
import API_URL from '../config';

function UnidadesPage({ empresa, usuario, onVoltar, onSair }) {
  const [unidades, setUnidades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState('');
  const [modalAberto, setModalAberto] = useState(false);
  const [form, setForm] = useState({ id: null, codigo: '', integracao: '', sigla: '', unidade: '', casas_decimais: 0 });
  const [editando, setEditando] = useState(false);
  const [pesquisa, setPesquisa] = useState('');
  const [confirmarExclusao, setConfirmarExclusao] = useState({ aberto: false, id: null });

  const fetchUnidades = async () => {
    setLoading(true);
    setErro('');
    try {
      console.log('empresa_id enviado:', empresa.id);
      const res = await fetch(`${API_URL}/unidades?empresa_id=${empresa.id}`);
      const data = await res.json();
      setUnidades(data);
    } catch (err) {
      setErro('Erro ao buscar unidades');
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchUnidades();
    // eslint-disable-next-line
  }, [empresa.id]);

  const abrirModal = (unidade = null) => {
    if (unidade) {
      setForm({ ...unidade });
      setEditando(true);
    } else {
      setForm({ id: null, codigo: '', integracao: '', sigla: '', unidade: '', casas_decimais: 0 });
      setEditando(false);
    }
    setErro('');
    setModalAberto(true);
  };

  const fecharModal = () => {
    setModalAberto(false);
    setForm({ id: null, codigo: '', integracao: '', sigla: '', unidade: '', casas_decimais: 0 });
    setEditando(false);
    setErro('');
  };

  const handleChange = e => {
    const { name, value } = e.target;
    if (name === 'sigla' || name === 'unidade') {
      setForm(f => ({ ...f, [name]: value.toUpperCase() }));
    } else {
      setForm(f => ({ ...f, [name]: value }));
    }
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setErro('');
    if (!form.sigla || !form.unidade) {
      setErro('Preencha os campos obrigatórios!');
      return;
    }
    try {
      const method = editando ? 'PUT' : 'POST';
      const url = editando ? `${API_URL}/unidades/${form.id}` : `${API_URL}/unidades`;
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          empresa_id: empresa.id,
          codigo: form.codigo,
          integracao: form.integracao,
          sigla: form.sigla,
          unidade: form.unidade,
          casas_decimais: Number(form.casas_decimais) || 0
        })
      });
      if (!res.ok) throw new Error('Erro ao salvar unidade');
      fecharModal();
      fetchUnidades();
    } catch (err) {
      setErro('Erro ao salvar unidade');
    }
  };

  const handleDelete = async id => {
    setConfirmarExclusao({ aberto: true, id });
  };

  const confirmarRemocao = async () => {
    try {
      await fetch(`${API_URL}/unidades/${confirmarExclusao.id}`, { method: 'DELETE' });
      fetchUnidades();
    } catch {
      setErro('Erro ao remover unidade');
    }
    setConfirmarExclusao({ aberto: false, id: null });
  };

  const cancelarRemocao = () => {
    setConfirmarExclusao({ aberto: false, id: null });
  };

  // Filtro de pesquisa
  const unidadesFiltradas = unidades.filter(u =>
    u.codigo.toLowerCase().includes(pesquisa.toLowerCase()) ||
    u.sigla.toLowerCase().includes(pesquisa.toLowerCase()) ||
    u.unidade.toLowerCase().includes(pesquisa.toLowerCase())
  );

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-100 to-blue-300">
      <Header usuario={usuario} empresa={empresa} onVoltar={onVoltar} onSair={onSair} />
      <div className="max-w-5xl mx-auto mt-10 bg-white rounded-lg shadow-lg p-6 relative">
        <h2 className="text-2xl font-bold text-blue-700 mb-6">Unidades</h2>
        <div className="mb-6 flex justify-end">
          <input
            type="text"
            value={pesquisa}
            onChange={e => setPesquisa(e.target.value)}
            placeholder="Pesquisar por código, sigla ou unidade..."
            className="border rounded px-3 py-2 w-full max-w-xs"
          />
        </div>
        {erro && <div className="text-red-600 mb-4">{erro}</div>}
        {loading ? (
          <div>Carregando...</div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
            {unidadesFiltradas.map(u => (
              <div key={u.id} className="bg-blue-50 rounded-lg shadow flex flex-col p-4 relative border border-blue-200">
                <div className="flex items-center justify-between mb-2">
                  <span className="font-bold text-blue-800 text-lg">{u.sigla}</span>
                  <div className="flex space-x-2">
                    <button onClick={() => abrirModal(u)} title="Editar" className="text-blue-600 hover:text-blue-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M15.232 5.232l3.536 3.536M9 13l6-6 3 3-6 6H9v-3z" /></svg>
                    </button>
                    <button onClick={() => handleDelete(u.id)} title="Excluir" className="text-red-600 hover:text-red-900">
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" /></svg>
                    </button>
                  </div>
                </div>
                <div className="text-gray-700 mb-1"><b>Código:</b> {u.codigo}</div>
                <div className="text-gray-700 mb-1"><b>Unidade:</b> {u.unidade}</div>
                <div className="text-gray-700 mb-1"><b>Integração:</b> {u.integracao || '-'}</div>
                <div className="flex justify-between items-center text-gray-700 mb-1">
                  <span><b>Casas Decimais:</b> {u.casas_decimais}</span>
                  <span className="text-xs text-gray-500 font-bold">ID: {u.id}</span>
                </div>
              </div>
            ))}
            {unidadesFiltradas.length === 0 && (
              <div className="col-span-full text-center py-8 text-gray-500">Nenhuma unidade encontrada.</div>
            )}
          </div>
        )}
        {/* Botão flutuante adicionar */}
        <button
          onClick={() => abrirModal()}
          className="fixed bottom-8 right-8 bg-blue-600 text-white rounded-full shadow-lg w-16 h-16 flex items-center justify-center text-3xl hover:bg-blue-700 transition z-50"
          title="Adicionar Unidade"
        >
          +
        </button>
        {/* Modal */}
        {modalAberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-md relative">
              <button onClick={fecharModal} className="absolute top-2 right-2 text-gray-400 hover:text-red-600 text-2xl">&times;</button>
              <h3 className="text-xl font-bold text-blue-700 mb-4">{editando ? 'Editar Unidade' : 'Nova Unidade'}</h3>
              <form onSubmit={handleSubmit} className="space-y-3">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Sigla*</label>
                  <input name="sigla" value={form.sigla} onChange={handleChange} className="border rounded px-3 py-2 w-full" required maxLength={5} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Unidade*</label>
                  <input name="unidade" value={form.unidade} onChange={handleChange} className="border rounded px-3 py-2 w-full" required maxLength={50} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Casas Decimais</label>
                  <input name="casas_decimais" type="number" min="0" max="6" value={form.casas_decimais} onChange={handleChange} className="border rounded px-3 py-2 w-full" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Código</label>
                  <input name="codigo" value={form.codigo} className="border rounded px-3 py-2 w-full bg-gray-100 cursor-not-allowed" readOnly />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Integração</label>
                  <input name="integracao" value={form.integracao} onChange={handleChange} className="border rounded px-3 py-2 w-full" maxLength={50} />
                </div>
                {erro && <div className="text-red-600 mb-2">{erro}</div>}
                <div className="flex justify-end space-x-2">
                  <button type="button" onClick={fecharModal} className="border border-blue-600 text-blue-600 px-4 py-2 rounded hover:bg-blue-50 transition">Cancelar</button>
                  <button type="submit" className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition">{editando ? 'Salvar' : 'Cadastrar'}</button>
                </div>
              </form>
            </div>
          </div>
        )}
        {/* Modal de confirmação de exclusão */}
        {confirmarExclusao.aberto && (
          <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm relative">
              <h4 className="text-lg font-bold mb-3">Remover Unidade</h4>
              <p className="mb-4">Deseja realmente remover esta unidade?</p>
              <div className="d-flex justify-content-end gap-2 flex-row-reverse">
                <button onClick={confirmarRemocao} className="btn btn-danger px-4 py-2 rounded me-2 bg-red-600 text-white hover:bg-red-700 transition">Remover</button>
                <button onClick={cancelarRemocao} className="btn btn-secondary px-4 py-2 rounded bg-light text-dark border hover:bg-gray-200 transition">Cancelar</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default UnidadesPage; 